import { notification } from 'antd';
import { useEffect, useState } from 'react';
import {
  CircleError,
  CircleExclamationSolid,
  CircleSuccess,
  TriangleExclamationSolid,
  XmarkSolid,
} from '../icons';
import { useMemorial } from '../../context/memorial.provider';

const getIsMobile = () => window.innerWidth < 768;

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const onResize = () => {
      setIsMobile(getIsMobile());
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isMobile;
};

export const notificationMessage = ({
  message,
  type,
}: {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}) => {
  const isMobile = getIsMobile();
  const commonIconStyle = 'flex relative top-[1px] mr-[8px] [&>svg]:w-[20px] [&>svg]:h-[20px]';
  let icon;

  if (type === 'success') {
    icon = (
      <div className={`${commonIconStyle} [&>svg>path]:fill-success`}>
        <CircleSuccess />
      </div>
    );
  } else if (type === 'error') {
    icon = (
      <div className={`${commonIconStyle} [&>svg>path]:fill-danger`}>
        <CircleError />
      </div>
    );
  } else if (type === 'info') {
    icon = (
      <div className={`${commonIconStyle} [&>svg>path]:fill-info`}>
        <CircleExclamationSolid />
      </div>
    );
  } else {
    icon = (
      <div className={`${commonIconStyle} [&>svg>path]:fill-warning`}>
        <TriangleExclamationSolid />
      </div>
    );
  }

  notification[type]({
    message: (
      <div className="flex">
        {icon}
        <p>{message}</p>
      </div>
    ),
    placement: isMobile ? 'top' : 'topRight',
    closeIcon: isMobile ? (
      false
    ) : (
      <div className="[&>svg>path]:fill-text2">
        <XmarkSolid />
      </div>
    ),
    icon: <></>,
  });
};

export const useCost = () => {
  const [cost, setCost] = useState<{ 0: string; 1: string; 2: string }>({
    0: '',
    1: '',
    2: '',
  });
  const { products } = useMemorial();

  useEffect(() => {
    if (products) {
      setCost({
        0: '',
        1: `${products.full.price} ${products.full.currency.toUpperCase()}`,
        2: `${products.offer.price} ${products.offer.currency.toUpperCase()}`,
      });
    }
  }, [products]);

  return cost;
};
